import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserIdFromToken } from "../utils/auth";
import { server } from "../server";

export const fetchMatches = createAsyncThunk(
  "matches/fetchMatches",
  async (_, { rejectWithValue }) => {
    try {
      const userId = getUserIdFromToken();
      const token = localStorage.getItem("authToken");

      if (!userId || !token) {
        return rejectWithValue("Unauthorized");
      }

      const res = await fetch(`${server}/matches?userId=${userId}`, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        throw new Error("Failed to fetch matches");
      }

      const data = await res.json();
      return data.profiles || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const matchesSlice = createSlice({
  name: "matches",
  initialState: {
    profiles: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearMatches: (state) => {
      state.profiles = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMatches.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMatches.fulfilled, (state, action) => {
        state.loading = false;
        state.profiles = action.payload;
      })
      .addCase(fetchMatches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearMatches } = matchesSlice.actions;
export default matchesSlice.reducer;
